module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0089.jpg?v=e06cf219";